import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import NameWhite from "../../images/Name_ivory_bg_transparent.png"
import NameBlack from "../../images/Name_night_bg_transparent.png"
import {
   smallScreenPortraitValue,
   smallScreenValue,
   medScreenValue,
} from "../../Responsive"
// Styles
import { Container, LogoImage } from "./Logo.styles"

const Logo = ({ bgImageColor }) => {
   const logoRef = useRef(null)
   const [scrollY, setScrollY] = useState(0)
   const [maxOffSet, setMaxOffset] = useState(0)

   useEffect(() => {
      const handleResize = () => {
         const screenHeight = window.innerHeight
         const screenWidth = window.innerWidth
         let logoHeight = 0
         let navbarHeight = 0

         if (screenWidth > medScreenValue) {
            logoHeight = 80
            navbarHeight = 100
         } else if (screenWidth > smallScreenValue) {
            logoHeight = 60
            navbarHeight = 80
         } else if (screenWidth > smallScreenPortraitValue) {
            logoHeight = 40
            navbarHeight = 60
         } else {
            logoHeight = 30
            navbarHeight = 40
         }
         setMaxOffset(screenHeight - navbarHeight - logoHeight)
      }

      const handleScroll = () => {
         setScrollY(window.scrollY)
      }

      handleResize()

      window.addEventListener("resize", handleResize)
      window.addEventListener("scroll", handleScroll)
      return () => {
         window.removeEventListener("scroll", handleScroll)
         window.removeEventListener("resize", handleResize)
      }
   }, [setScrollY, maxOffSet])

   const translateY = Math.max(-scrollY, -maxOffSet)

   return (
      <Container positionY={translateY} ref={logoRef}>
         <LogoImage src={bgImageColor === "dark" ? NameWhite : NameBlack} />
      </Container>
   )
}

Logo.propTypes = {
   bgImageColor: PropTypes.string,
}

export default Logo
